var React = require('react');

function UmbrellaOpen48px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M48 22.42c0 1.301-1.536 3.14-3 3.14H25v15.161c0 3.996-3.219 7.245-7.176 7.245-3.954 0-6.824-2.883-6.824-6.858 0-.555.447-1.008 1-1.008.553 0 1 .453 1 1.008 0 2.898 1.938 4.843 4.824 4.843 2.854 0 5.176-2.347 5.176-5.23V25.56H3c-1.362 0-3-1.648-3-3.09C0 11.148 11.408 5.091 23 4.76V.99c0-.556.447-1.008 1-1.008.553 0 1 .452 1 1.008v3.77c11.592.33 23 6.37 23 17.66zM24 6.743c-10.933 0-22 5.402-22 15.727 0 .303-.245 1.09 0 1.09h21.224a.98.98 0 0 1 .776-.398c.32 0 .593.162.776.398H45c.22 0 1-.795 1-1.14C46 12.127 34.932 6.743 24 6.743z","key":1})]);
}

UmbrellaOpen48px.displayName = "UmbrellaOpen48px";

UmbrellaOpen48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 47.97"};

module.exports = UmbrellaOpen48px;

UmbrellaOpen48px.default = UmbrellaOpen48px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/umbrella-open-48px.svg
// module id = 1171
// module chunks = 0